import defaults from '../config/default/config.json';
import configConnect from 'preconf';

export const configure = configConnect(null, defaults);
